import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { RTL_LOCALES, normalizeAppLocale } from '@/i18n/languages';

export default function AppToastContainer() {
  const { i18n } = useTranslation();
  const isRtl = RTL_LOCALES.has(normalizeAppLocale(i18n.language));

  return (
    <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={isRtl}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      className="compact-toast-container"
      toastClassName="compact-toast"
      bodyClassName="compact-toast-body"
    />
  );
}
